import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/more.svg'
import _imports_1 from '@/assets/icons/edit.svg'
import _imports_2 from '@/assets/icons/target.svg'


const _withScopeId = n => (_pushScopeId("data-v-5bb98efe"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-row items-center mb-8 pt-4 justify-between space-x-3 mt-4" }
const _hoisted_2 = { class: "flex flex-row w-full" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-6 w-6",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor",
  "stroke-width": "2"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    d: "M12 6v6m0 0v6m0-6h6m-6 0H6"
  })
], -1))
const _hoisted_4 = { class: "flex" }
const _hoisted_5 = {
  key: 0,
  class: "text-green-500"
}
const _hoisted_6 = {
  key: 1,
  class: "text-red-500"
}
const _hoisted_7 = ["onClick"]
const _hoisted_8 = ["onClick"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = {
  key: 0,
  class: "absolute flex flex-col text-black bg-white right-0 mr-10 mt-4 rounded-2xl shadow hover:shadow-md p-2 w-72 z-50"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row items-center" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }),
  /*#__PURE__*/_createElementVNode("span", { class: "txt-name text-left ml-4" }, "Edit")
], -1))
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = ["onClick"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row items-center" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_2 }),
  /*#__PURE__*/_createElementVNode("span", { class: "txt-name text-left ml-4" }, "Deactivate")
], -1))
const _hoisted_16 = [
  _hoisted_15
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SearchInput = _resolveComponent("SearchInput")!
  const _component_Button = _resolveComponent("Button")!
  const _component_VueTableLite = _resolveComponent("VueTableLite")!
  const _component_Paginator = _resolveComponent("Paginator")!
  const _component_CreateMemberForm = _resolveComponent("CreateMemberForm")!
  const _component_ReusableModal = _resolveComponent("ReusableModal")!
  const _directive_click_away = _resolveDirective("click-away")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_SearchInput, {
            modelValue: _ctx.inputValue,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.inputValue) = $event)),
            class: "bg-white",
            placeholder: "Search for staff...",
            onOnSubmit: _ctx.getMembers
          }, null, 8, ["modelValue", "onOnSubmit"])
        ]),
        _createElementVNode("div", null, [
          _createVNode(_component_Button, {
            sizeText: "text-sm",
            onOnClick: _cache[1] || (_cache[1] = 
            () => {
              _ctx.openModal = true;
              _ctx.client = {};
              _ctx.setKey('create');
              _ctx.closeMenu();
            }
          ),
            label: "Add new staff member",
            variant: "contained"
          }, {
            startIcon: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          })
        ])
      ]),
      _createVNode(_component_VueTableLite, {
        "is-loading": _ctx.table.isLoading,
        columns: _ctx.table.columns,
        rows: _ctx.table.rows,
        total: _ctx.table.totalRecordCount,
        sortable: _ctx.table.sortable,
        "is-hide-paging": true,
        "is-slot-mode": ""
      }, {
        name: _withCtx((data) => [
          _createElementVNode("span", {
            class: _normalizeClass({
            'text-gray-400 italic':
              !data.value.first_name && !data.value.last_name,
          })
          }, _toDisplayString(data.value.first_name && data.value.last_name
              ? `${data.value?.first_name} ${data.value?.last_name}`
              : "Pending"), 3)
        ]),
        roles: _withCtx((data) => [
          _createElementVNode("span", null, _toDisplayString(data.value?.roles?.join(", ")), 1)
        ]),
        email: _withCtx((data) => [
          _createElementVNode("span", null, _toDisplayString(data?.value?.email), 1)
        ]),
        status: _withCtx((data) => [
          _createElementVNode("div", _hoisted_4, [
            (data.value.status === 'active')
              ? (_openBlock(), _createElementBlock("span", _hoisted_5, " Active "))
              : _createCommentVNode("", true),
            (!data.value || data.value.status === 'deactivated')
              ? (_openBlock(), _createElementBlock("span", _hoisted_6, " Deactivated "))
              : _createCommentVNode("", true),
            (data.value.status === 'inactive')
              ? (_openBlock(), _createElementBlock("button", {
                  key: 2,
                  class: "btn-text text-sm",
                  onClick: ($event: any) => (_ctx.resendInvitation(data.value.id))
                }, " Resend invitation ", 8, _hoisted_7))
              : _createCommentVNode("", true)
          ])
        ]),
        menu: _withCtx((data) => [
          _createElementVNode("button", {
            class: "px-2",
            onClick: ($event: any) => (_ctx.openDropDown(data.value))
          }, _hoisted_10, 8, _hoisted_8),
          (data.value.id === _ctx.currentDropdown)
            ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createElementVNode("button", {
                  class: "hover:bg-background p-4 rounded",
                  onClick: _cache[2] || (_cache[2] = 
              () => {
                _ctx.openModal = true;
                _ctx.setKey('edit');
                _ctx.closeMenu();
              }
            )
                }, _hoisted_13),
                (data.value.status === 'active')
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: "hover:bg-background p-4 rounded",
                      onClick: ($event: any) => (_ctx.deactivateMember(data.value.id))
                    }, _hoisted_16, 8, _hoisted_14))
                  : _createCommentVNode("", true)
              ])), [
                [_directive_click_away, _ctx.closeMenu]
              ])
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["is-loading", "columns", "rows", "total", "sortable"]),
      _createVNode(_component_Paginator, {
        modelValue: _ctx.page,
        page: _ctx.page,
        pages: _ctx.pagination.total_pages,
        "range-size": 1,
        "onUpdate:modelValue": _ctx.updateHandler,
        total: _ctx.pagination.total_count,
        from: _ctx.pagination.from,
        to: _ctx.pagination.to
      }, null, 8, ["modelValue", "page", "pages", "onUpdate:modelValue", "total", "from", "to"])
    ]),
    _createVNode(_component_ReusableModal, {
      show: _ctx.openModal,
      onClose: _cache[4] || (_cache[4] = ($event: any) => (_ctx.openModal = false)),
      size: "w-1/3"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_CreateMemberForm, {
          data: _ctx.client,
          keyOption: _ctx.key,
          products: _ctx.products,
          onCloseModal: _cache[3] || (_cache[3] = ($event: any) => (_ctx.openModal = false)),
          onReloadData: _ctx.getMembers
        }, null, 8, ["data", "keyOption", "products", "onReloadData"])
      ]),
      _: 1
    }, 8, ["show"])
  ], 64))
}